export default {
    pathParams: 'design',
    animation: 'design',
    headline: 'Проектирование',
    headlineSmall: 'Проектиро\u00ADвание',
    isDescComponent: false,
    description: 'Для перехода от\u00A0данных к\u00A0идеям и\u00A0решениям мы\u00A0используем различные креативные методики — дизайн-мышление, латеральное мышление, CRAFT. Наш собственный подход Focus представляет из\u00A0себя методологию быстрого решения сложных бизнес-задач и\u00A0вывода продуктов на\u00A0рынок',
    services: [],
};
